module.exports = __webpack_public_path__ + "static/img/ic_drugstore@2x.6fc288e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_drugstore@2x.png
// module id = JKsN
// module chunks = 1